<div class="header">
  <div class="icon">
    <button *ngIf="idDisplay"  mat-icon-button (click)="handleMenuClick()">
      <mat-icon>menu</mat-icon>
    </button>
  </div>
  <h1><a href="/">Tweet Map</a></h1>
  <div class="spacer"></div>
</div>